@if (choosenStops$ | async; as choosenStops) {
  @if (deviationType$ | async; as deviationType) {
    @if (choosenStops.length) {
      <div class="selected-results">
        @for (stop of choosenStops; track (stop.placeId || $index)) {
          <input type="checkbox" class="selected-item-input" [id]="stop.placeId" [checked]="stop.selectedZoom" />
          @if ({value: existingTrafficDeviationLoaded$ | async}; as existingTrafficDeviationLoaded) {
            <div
              class="selected-item"
              [ngClass]="{'stop-area': stop.type === 'StopArea'}"
              (click)="onClickSelectedStop(stop)"
              (clickOutside)="unselectZoom(stop)"
              >
              @if (stop.type === 'StopArea') {
                <div class="stop-area-header">
                  <div class="text">
                    <div class="stop-title">
                      <p class="base-alt">{{ stop.description }}</p>
                      <div class="region-info">
                        <i class="fa-solid fa-warehouse region-icon"></i>
                        <span class="region-name">{{ stop.hastusRegion }}</span>
                      </div>
                    </div>
                    <p class="caption">{{ 'The stop platforms will be handled in the following way' | translate }}</p>
                    @if (
                      deviationType.deviationInformation
                      && !existingTrafficDeviationLoaded.value
                    ) {
                      <div class="only-effects-stop">
                        <div class="custom-checkbox">
                          <input
                            type="checkbox"
                            [id]="'effectsStopsOnly-'+stop.placeId"
                            [checked]="stop.stopCentric"
                            (click)="toggleEffectedRoutesOnStop($event, stop)"
                            click-stop-propagation
                            #effectsStopsOnly />
                            <span class="focus-background"></span>
                        </div>
                        <label [for]="'effectsStopsOnly-'+stop.placeId" class="caption" click-stop-propagation translate>CHECKBOX_EFFECTS_STOPS_ONLY</label>
                      </div>
                    }
                    @if (!existingTrafficDeviationLoaded.value) {
                      <app-validation-message [control]="getStopAreaControl(stop, deviationType.journeyPattern)"></app-validation-message>
                    }
                  </div>
                  @if (!existingTrafficDeviationLoaded.value) {
                    <div class="close">
                      <button type="button" (click)="onClickRemoveStop(stop)" click-stop-propagation>
                        <app-svg-icon [path]="'assets/icons/x-mark.svg'"></app-svg-icon>
                      </button>
                    </div>
                  }
                </div>
                <ng-container *ngTemplateOutlet="stopPlace; context: { 
                    $implicit: stop.stopPlaces, 
                    existingTrafficDeviationLoaded: existingTrafficDeviationLoaded, 
                    stop: stop }">
                </ng-container>
              }
              @if (stop.type !== 'StopArea') {
                <ng-container *ngTemplateOutlet="stopPlace; context: { 
                      $implicit: [stop], 
                      existingTrafficDeviationLoaded: existingTrafficDeviationLoaded }">
                </ng-container>
              }
            </div>
          }
        }
      </div>
    }
  }
}

<ng-template #stopPlace let-stopPlaces let-existingTrafficDeviationLoaded="existingTrafficDeviationLoaded" let-stop="stop">
  @for (stopPlace of stopPlaces; track trackByKey.bind(this, 'placeId')($index, stopPlace)) {
    <div class="stop-point">
      @if (deviationType$ | async; as deviationType) {
        <div class="header">
          <div class="text">
            <p class="caption-bold"
              [ngClass]="{'line-through': stopPlace.active && deviationType.journeyPattern}">
              {{ stopPlace.description }} {{ stopPlace.platformCode }}
            </p>
            @if (stopPlace.active) {
              @if (deviationType.journeyPattern) {
                <p class="caption">{{ 'The stop platform has been rescheduled for the following lines' | translate }}</p>
              }
              @if (!deviationType.journeyPattern) {
                <p class="caption">{{ 'Stop platform affected' | translate }}</p>
              }
            }
            @if (!stopPlace.active) {
              @if (deviationType.journeyPattern) {
                <p class="caption">{{ 'The stop platform not affected by the rerouting' | translate }}</p>
              }
              @if (!deviationType.journeyPattern) {
                <p class="caption">{{ 'Stop platform not affected' | translate }}</p>
              }
            }
          </div>
          @if (stop && !existingTrafficDeviationLoaded.value) {
            <div class="switch">
              <app-form-switch
                [checkboxValue]="stopPlace.active"
                (toggleCallback)="toggleStopPoint($event, stopPlace)">
              </app-form-switch>
            </div>
          }
          @if (!stop && !existingTrafficDeviationLoaded.value) {
            <div class="close">
              <button type="button" (click)="onClickRemoveStop(stopPlace)">
                <app-svg-icon [path]="'assets/icons/x-mark.svg'"></app-svg-icon>
              </button>
            </div>
          }
        </div>
        @if (stopPlace.active) {
          <div class="routes">
            @for (route of stopPlace.effectedRoutes; track trackByKey.bind(this, 'templateTripId')($index, route)) {
              <button
                type="button"
                class="route"
                [title]="route.firstStopDestinationSign"
                [ngClass]="{'active': route.active}"
                (click)="!existingTrafficDeviationLoaded.value && onClickToggleRoute(route, stopPlace, stop)"
                click-stop-propagation>
                {{ route.routeName }}
              </button>
            }
          </div>
          <app-validation-message [control]="getEffectedRoutesControl(stopPlace, stop)"></app-validation-message>
        }
        @if (stopPlace.active && deviationType.journeyPattern) {
          <div class="replace-stop">
            <fieldset>
              <div class="form-group">
                <label class="label-above" [for]="'replace-'+stopPlace.placeId">{{ 'New stop platform' | translate }}</label>
                @if (!existingTrafficDeviationLoaded.value) {
                  <div class="replace-input-wrapper"
                    [ngClass]="{'error': getReplaceStopControl(stopPlace).invalid && (getReplaceStopControl(stopPlace).touched || getReplaceStopControl(stopPlace).dirty)}">
                    <input
                      [id]="'replace-'+stopPlace.placeId"
                      class="replace-input"
                      (keyup)="onKeyupReplaceStop($event, stopPlace)"
                      (keyup.enter)="selectSingleResult(stopPlace)"
                      (keyup.esc)="updateSearchResultsFocus('')"
                      (keyup.arrowDown)="onSearchInputKeyDown($event, stopPlace)"
                      (focus)="updateSearchResultsFocus(stopPlace.placeId); handleAccessibility(stopPlace)"
                      (blur)="onReplaceStopBlur(stopPlace)"
                      (input)="onReplaceStopInput(stopPlace)"
                      [value]="stopPlace.replaceName"
                      autocomplete="off"
                      placeholder="{{ 'Search' | translate }} {{ 'stop platform' | translate }}"
                      click-stop-propagation
                      #replacestopPlaceInput
                      />
                  </div>
                }
                @if (existingTrafficDeviationLoaded.value) {
                  <input
                    [id]="'replace-'+stopPlace.placeId"
                    [value]="stopPlace.replaceName"
                    click-stop-propagation
                    readonly
                    />
                }
                @if ({value: searchStopsLoader$ | async}; as searchStopsLoader) {
                  @if (!searchStopsLoader.value[stopPlace.placeId]) {
                    <app-svg-icon
                      class="search suffix"
                      [path]="'assets/icons/search.svg'"
                      >
                    </app-svg-icon>
                  }
                  @if (searchStopsLoader.value[stopPlace.placeId]) {
                    <places-spinner
                      class="suffix"
                      >
                    </places-spinner>
                  }
                }
                @if ((stopPlacesSearchResultsFocus$ | async) === stopPlace.placeId) {
                  <div
                    class="search-results"
                    (clickOutside)="this.updateSearchResultsFocus('')"
                    #searchResultsContainer>
                    @for (result of stopPlace.stopSearchResults; track trackByKey.bind(this, 'placeId')($index, result)) {
                      <input type="checkbox" [id]="'result-'+result.placeId" [checked]="result.selected">
                      <div class="result" (click)="onClickSelectReplaceStop(result, stopPlace)" click-stop-propagation>
                        <div class="description">
                          {{ result.description }} {{ result.platformCode }}
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>
            </fieldset>
            
            <app-validation-message [control]="getReplaceStopControl(stopPlace)"></app-validation-message>
          </div>
        }
      }
    </div>
  }
</ng-template>